<template>
  <v-tooltip :disabled="disabled" top>
    <template v-slot:activator="{ on }">
      <div
        class="no-wrap"
        style="display: inline-block"
        v-on="on"
      >
        <v-rating
          v-model="value.rating"
          :readonly="disabled"
          :size="tamanho"
          :color="cor"
          background-color="grey"
          @input="$emit('return', value.rating)"
        />
      </div>
    </template>
    <span>Clique para avaliar</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AppRating',

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        rating: 0,
      }),
    },
    cor: {
      type: String,
      required: false,
      default: 'secondary',
    },
    tamanho: {
      type: Number,
      required: false,
      default: 28,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
